
import React from "react";
import Navbar from "../Components/Navbar";
import DateHelpers from "../Helper/DateHelpers";
import AdminReservationCardList from "../Components/AdminReservationCardList";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Session from 'react-session-api';
import Footer from "../Components/Footer";
import '../Styles/ReservationSearch.scss';
import { Helmet } from "react-helmet";
import EventReporting from "./EventReporting";


function ReservationSearch() {

   const [queriedReservations, setQueriedReservations] = useState()
   const [searchSelection, setSearchSelection] = useState('')
   const [openEvents, setOpenEvents] = useState()
   const [camperCount, setCamperCount] = useState()
   const [maleCount, setMaleCount] = useState()
   const [femaleCount, setFemaleCount] = useState()
   const [archivedEvents, setArchivedEvents] = useState()
   const [selectedEvents, setSelectedEvents] = useState()
   const [reservationCount, setReservationCount] = useState()
   const [deluxeCountWeekOne, setDeluxeCountWeekOne] = useState()
   const [deluxeCountWeekTwo, setDeluxeCountWeekTwo] = useState()
   const [deluxeCountWeekThree, setDeluxeCountWeekThree] = useState()
   const [estimatedCamperSum, setEstimatedCamperSum] = useState()
   const [reservationSearchCriteria, setReservationSearchCriteria] = useState({
      eventName: 'All Events'
   });
   const navigate = useNavigate()

   const getOpenEventsOnPageLoad = async () => {
      try {
         var eventStatus = true;
         const eventResponse = await fetch('/getallevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventStatus })
         })

         const events = await eventResponse.json();
         var selectedEvents = events.data;
         console.log("Here's open events", selectedEvents.eventInfo)
         var mappedEvents = selectedEvents.eventInfo.map((selectedEvent) => <option key={selectedEvent.camp_name} value={selectedEvent.event_id}>{selectedEvent.camp_name + ': ' + DateHelpers.getDisplayDate(selectedEvent.begin_date) + '-' + DateHelpers.getDisplayDate(selectedEvent.end_date)}</option>)
         console.log("mapped events", mappedEvents)
         setOpenEvents(mappedEvents)
      } catch (error) {
         console.log(error)
      }
   }

   const getArchivedEventsOnPageLoad = async () => {
      try {
         var eventStatus = false;
         const eventResponse = await fetch('/getallevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventStatus })
         })

         const events = await eventResponse.json();
         var selectedEvents = events.data;
         console.log("Here's archived events", selectedEvents.eventInfo)
         var mappedEvents = selectedEvents.eventInfo.map((selectedEvent) => <option key={selectedEvent.camp_name} value={selectedEvent.event_id}>{selectedEvent.camp_name + ': ' + DateHelpers.getDisplayDate(selectedEvent.begin_date) + '-' + DateHelpers.getDisplayDate(selectedEvent.end_date)}</option>)
         setArchivedEvents(mappedEvents)
         setSelectedEvents(mappedEvents)

      } catch (error) {
         console.log(error)
      }
   }


   const getReservationsOnPageLoad = async () => {
      try {
         console.log("transaction search criteria", reservationSearchCriteria)

         // Get Transactions
         const defaultTransactions = await fetch('/getreservations', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               reservationSearchCriteria,
               searchSelection
            })
         })
         var response = await defaultTransactions.json()
         console.log("Here's default Transactions", response)
         setDeluxeCountWeekOne(response.data.deluxeRoomCounts[0].reservation_count)
         setDeluxeCountWeekTwo(response.data.deluxeRoomCounts[1].reservation_count)
         setDeluxeCountWeekThree(response.data.deluxeRoomCounts[2].reservation_count)
         setQueriedReservations(response.data.reservations)
         setEstimatedCamperSum(response.data.camperSum[0].total_campers)
         setCamperCount(response.data.counts[0].count)
         setMaleCount(response.data.maleCounts[0].count)
         setFemaleCount(response.data.femaleCounts[0].count)
      } catch (error) {

      }
   }

   // const handleClick = () => {
   //    const registrations = queriedRegistrations
   //    console.log('registrations', registrations)
   //    navigate('/reporting', { state: registrations });
   // };

   // Load events on page load
   useEffect(() => {
      getArchivedEventsOnPageLoad()
      getOpenEventsOnPageLoad()
   }, [])

    useEffect(() => {
      getReservationsOnPageLoad()
   }, [archivedEvents || openEvents])

   useEffect(() => {
      if(!reservationSearchCriteria.eventName){
         return
      }

      getReservationsOnPageLoad()
   }, [reservationSearchCriteria.eventName]);


      useEffect(() => {
      if(!queriedReservations){
         return
      }
      console.log("total count",queriedReservations[0].total_count)

      setReservationCount(queriedReservations[0].total_count)
   }, [queriedReservations]);

   return (
      <div className="ReservationSearchBackground">
         <div className="ReservationSearchForeground">
            <div className="ReservationSearchHeading">
               <div
                  className="ReservationSearchInvisibleDiv">
               </div>
               <div className='ReservationSearchHeadingText'>
                  View and Manage Church Groups
               </div>
               <div className="ReservationSearchHeadingBackButton">

               </div>
            </div>

            <div className="ReservationSearchSelectOptions">
               <div className="ReservationSearchSearch">
                  <div className="ReservationSearchSearchText">
                     <input
                        id='transactionSearch'
                        type='text'
                        value={searchSelection}
                        placeholder="Group Name"
                        onChange={(event) => setSearchSelection(event.target.value)}
                     />
                  </div>
                  <div className="ReservationSearchSearchButton">
                     <button onClick={(event) => getReservationsOnPageLoad()}>
                        Search
                     </button>
                  </div>
               </div>

               <div className='ReservationSearchDropdownOne'>
                  <select
                     value={reservationSearchCriteria.eventName}
                     onChange={(event) => setReservationSearchCriteria({ ...reservationSearchCriteria, eventName: (event.target.value) })}
                  >
                     <option value="All Events">All Open Events</option>
                     {
                        openEvents
                     }
                  </select>

               </div>
               <div className='ReservationSearchDropdownTwo'>

                  <select
                     value={reservationSearchCriteria.eventName}
                     onChange={(event) => setReservationSearchCriteria({ ...reservationSearchCriteria, eventName: (event.target.value) })}
                  >
                     <option value="All Events">All Archived Events</option>
                     {
                        archivedEvents
                     }
                  </select>
               </div>
               <div className="ReservationSearchReports">
                  {/* <button onClick={handleClick}>
                     Day Camp Reports
                  </button> */}
               </div>
            </div>
            <div className="ReservationSearchCamperCount">
               <div className="ReservationSearchTotalCount">
                  <div className="ReservationSearchTotalCountHeading">
                     Reservation Count
                  </div>
                  <div className="ReservationSearchTotalCountNumber">
                   {reservationCount}
                  </div>
               </div>
               <div className="ReservationSearchEstimatedCamperCount">
                  <div className="ReservationSearchEstimatedCamperCountHeading">
                     Estimated Camper Count
                  </div>
                  <div className="ReservationSearchEstimatedCamperCountNumber">
                     {estimatedCamperSum}
                  </div>
               </div>
               <div className="ReservationSearchDeluxeCount">
                  <div className="ReservationSearchDeluxeCountHeading">
                     Deluxe Rooms Count
                  </div>
                  <div className="ReservationSearchDeluxeCountNumber">
                     <div>
                        Jr/Youth/Deaf Week 1: {deluxeCountWeekOne}
                     </div>
                     <div>
                        Jr/Youth/Deaf Week 2: {deluxeCountWeekTwo}
                     </div>
                     <div>
                        Jr/Youth/Deaf Week 3: {deluxeCountWeekThree}
                     </div>
                  </div>
               </div>
            </div>
            <div className="ReservationSearchRegistrations">
               <AdminReservationCardList
                  queriedReservations={queriedReservations} />
            </div>
         </div>
      </div>
   )
};

export default ReservationSearch;